import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import SEOHead from './SEOHead';
import Nav from './Nav';
import AIAudioSummarizerHero from './AIAudioSummarizerHero';
import StatsCounter from './StatsCounter';
import AIAudioFileFormats from './AIAudioFileFormats';

import AIHowItWorks from './AIHowItWorks';
import ReviewsSection from './ReviewsSection';
import FAQSection from './FAQSection';
import AIFinalCTA from './AIFinalCTA';
import ScrollWrap from './ScrollWrap';
import BenefitsGrid from './BenefitsGrid';
import AudioSummarizerSEOContent from './AudioSummarizerSEOContent';
import Footer from './Footer';
import AOS from 'aos';
import 'aos/dist/aos.css';

function AIAudioSummarizerPage() {
  const { lang } = useParams();
  const { setLanguage } = useLanguage();

  useEffect(() => {
    if (lang && (lang === 'en' || lang === 'ar')) {
      setLanguage(lang);
    }
  }, [lang, setLanguage]);

  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: true,
      offset: 100
    });
  }, []);

  // SEO content for AI Audio Summarizer page
  const seoContent = {
    en: {
      title: "Audio to Text, AI Summary, Document, Audio Summary & Video Summary",
      description: "Convert audio to text with AI. Generate smart summaries from meetings, podcasts & lectures. 99% accuracy, 95+ languages. Free signup.",
      keywords: "AI audio summarizer, audio analysis, intelligent transcription, meeting summarizer, podcast analysis, lecture notes, interview transcription"
    },
    ar: {
      title: "ملخص الصوت بالذكاء الاصطناعي - تحليل وتلخيص متقدم | لَخِّصْ",
      description: "تلخيص صوتي بالذكاء الاصطناعي. تحويل الصوت إلى نص وملخصات ذكية. دقة 99%+ لأكثر من 95 لغة. تسجيل مجاني.",
      keywords: "ملخص صوتي بالذكاء الاصطناعي, تحليل صوتي, تحليل ذكي للصوت, ملخص الاجتماعات, تحليل البودكاست, ملاحظات المحاضرات"
    }
  };

  const currentLang = lang || 'en';

  return (
    <div>
      <SEOHead 
        title={seoContent[currentLang].title}
        description={seoContent[currentLang].description}
        keywords={seoContent[currentLang].keywords}
      />
      <Nav />
      <AIAudioSummarizerHero />
      
      {/* Benefits Grid Section - Cards layout above Upload Demo */}
      <BenefitsGrid />
      
      <AIHowItWorks />
      <ScrollWrap />
      
      {/* SEO-Optimized Content Section */}
      <AudioSummarizerSEOContent />
      
      <AIAudioFileFormats />
      
      {/* Stats Counter Section - Above FAQ */}
      <StatsCounter 
        showHeading={true}
        title="Trusted by Thousands Worldwide"
        subtitle="Helping students and professionals save thousands of hours of manual work"
      />
      
      <FAQSection />
      
      {/* Reviews Section - Positioned after FAQ section */}
      <div className="container px-4" style={{ paddingTop: '3rem', paddingBottom: '3rem' }}>
        <ReviewsSection />
      </div>
      
      <AIFinalCTA />
      
      <Footer />
    </div>
  );
}

export default AIAudioSummarizerPage;